import { render, staticRenderFns } from "./PromForm.vue?vue&type=template&id=0cbbb676&scoped=true"
import script from "./PromForm.vue?vue&type=script&lang=js"
export * from "./PromForm.vue?vue&type=script&lang=js"
import style0 from "./PromForm.vue?vue&type=style&index=0&id=0cbbb676&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbbb676",
  null
  
)

export default component.exports